import { defaultTheme } from 'gd-design-library';
import { firaSans } from 'pages/_app';

export const font = {
  ...defaultTheme.font,
  family: firaSans.style.fontFamily
};
